/**
 * A natív dátum-mező év-szakasza addig gyűjti a számjegyeket, amíg a felső határ szerint
 * hosszabb évszám is kijöhet - felső határ nélkül hatig, mert a szabvány 275760-ig enged évet.
 * Ezért nem lép át magától a hónapra négy számjegy után. Egy négyjegyű felső határ ezt
 * megszünteti, és érdemben semmit nem korlátoz: 9999 utáni dátumot nem rögzít senki.
 *
 * A mezőt nem a hívó helyen kötjük meg, hanem fókuszáláskor, egy helyen: a felületen
 * több tucat dátum-mező van, és a következőt senki nem fogja megjelölni.
 */
const MAX_BY_TYPE = {
    'date': '9999-12-31',
    'datetime-local': '9999-12-31T23:59',
};

const applyBound = (element) => {
    if (!element || element.tagName !== 'INPUT' || element.hasAttribute('max')) {
        return;
    }

    const max = MAX_BY_TYPE[element.type];

    if (max) {
        element.setAttribute('max', max);
    }
};

/**
 * A beágyazott naptár idegen oldalon fut, ezért ott a saját gyökerére figyelünk, nem a
 * dokumentumra - a beágyazó lap mezőihez nem nyúlunk.
 */
export const watchDateInputs = (root = document) => {
    root.addEventListener('focusin', (event) => applyBound(event.target), true);
};

export default {
    install() {
        watchDateInputs(document);
    },
};
